export default "__VITE_ASSET__CByErwlb__"